module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/connect.com-infinity-icon-color.png"